"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getElements = getElements;
const chemical_elements_1 = require("chemical-elements");
const Kind_1 = require("../Kind");
/**
 * @param {*} parts
 */
function getElements(parts) {
    const elements = [];
    for (const part of parts) {
        for (const line of part) {
            let number = line.multiplier;
            switch (line.kind) {
                case Kind_1.Kind.ATOM: {
                    let symbol = line.value;
                    let element = chemical_elements_1.elementsObject[symbol];
                    if (!element) {
                        throw new Error(`element unknown: ${symbol} - ${line}`);
                    }
                    addElement(elements, { symbol, number });
                    break;
                }
                case Kind_1.Kind.ISOTOPE: {
                    let element = chemical_elements_1.elementsAndIsotopesObject[line.value.atom];
                    if (!element) {
                        throw new Error(`element unknown: ${part.value.atom} - ${line}`);
                    }
                    let isotope = element.isotopes.find((a) => a.nominal === line.value.isotope);
                    if (!isotope) {
                        throw new Error(`isotope unknown: ${line.value.isotope} - ${line}`);
                    }
                    addElement(elements, {
                        symbol: line.value.atom,
                        number,
                        isotope: line.value.isotope,
                    });
                    break;
                }
                default:
                    throw new Error(`unknown type: ${line.kind}`);
            }
        }
    }
    return elements;
}
function addElement(elements, newElement) {
    for (let element of elements) {
        if (element.symbol === newElement.symbol &&
            element.isotope === newElement.isotope) {
            element.number += newElement.number;
            return;
        }
    }
    elements.push(newElement);
}
//# sourceMappingURL=getElements.js.map